(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-notification', {
            parent: 'entity',
            url: '/customer-notification?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.customerNotification.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-notification/customer-notifications.html',
                    controller: 'CustomerNotificationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                phone: "",
                langKey: null,
                eventType: null,
                status: null,
                fromDate: null,
                toDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        phone: $stateParams.phone,
                        langKey: $stateParams.langKey,
                        clients: $stateParams.clients,
                        eventType: $stateParams.eventType,
                        status: $stateParams.status,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerNotification');
                    $translatePartialLoader.addPart('notificationStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-notification-detail', {
            parent: 'customer-notification',
            url: '/customer-notification/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.customerNotification.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-notification/customer-notification-detail.html',
                    controller: 'CustomerNotificationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customerNotification');
                    $translatePartialLoader.addPart('notificationStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CustomerNotification', function($stateParams, CustomerNotification) {
                    return CustomerNotification.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'customer-notification',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('customer-notification-detail.edit', {
            parent: 'customer-notification-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-notification/customer-notification-dialog.html',
                    controller: 'CustomerNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerNotification', function(CustomerNotification) {
                            return CustomerNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-notification.new', {
            parent: 'customer-notification',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-notification/customer-notification-dialog.html',
                    controller: 'CustomerNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                message: null,
                                language: null,
                                collapseKey: null,
                                eventType: null,
                                url: null,
                                readStatus: null,
                                status: null,
                                deleted: null,
                                pushDate: null,
                                expiryDate: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer-notification', null, { reload: 'customer-notification' });
                }, function() {
                    $state.go('customer-notification');
                });
            }]
        })
        .state('customer-notification.edit', {
            parent: 'customer-notification',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-notification/customer-notification-dialog.html',
                    controller: 'CustomerNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerNotification', function(CustomerNotification) {
                            return CustomerNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-notification', null, { reload: 'customer-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer-notification.delete', {
            parent: 'customer-notification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer-notification/customer-notification-delete-dialog.html',
                    controller: 'CustomerNotificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CustomerNotification', function(CustomerNotification) {
                            return CustomerNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-notification', null, { reload: 'customer-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
